<template>
  <vuestic-widget :headerText="$t(title)" :cancelButton="true" :cancelRoute="cancelRoute">
    <table class="table first-td-padding object-table">
      <thead v-if="tableHeader">
        <tr>
          <th width="25%"></th>
          <th width="75%"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="field in tableFields" v-if="object !== undefined">
            <td class="key">{{ field.title }}</td>
            <td v-if="field.type === 'date'">{{ object[field.name] | formatDate }}</td>
            <td v-else-if="field.type === 'link'">
              <router-link :key="field.name" :to="{ name: field.path, params: { id: object[field.id] || $route.params.id }}">
                {{ field.title }}
              </router-link>
            </td>
            <td v-else-if="field.type === 'hyperlink'">
              <a :href="object[field.name]">{{ field.title }}</a>
            </td>
            <td v-else-if="field.type === 'password'">
              *********
            </td>
            <td v-else-if="field.type === 'money'">
              ${{ object[field.name] | formatFloat }}
              <span v-if="field.unit"> {{field.unit}}</span>
            </td>
            <td v-else-if="field.type === 'percentage'">
              {{ object[field.name] | formatFloat }}%
            </td>
            <td v-else>{{ object[field.name] }}</td>
        </tr>
      </tbody>
    </table>
    <div class="row actions">
      <div class="col-md-6 offset-md-6 text-right">
        <button class="btn btn-danger btn-sm" @click="showDeleteModal()" v-if="canDelete">
          <div class="btn-with-icon-content">
            <i class="ion-md-close ion"></i>
            Delete
          </div>
        </button>
        <button class="btn btn-success btn-sm" @click="editContact()" v-if="canUpdate">
          Edit
        </button>
      </div>
    </div>
  </vuestic-widget>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'
  import store from '../../../store'
  export default {
    name: 'show-object',
    mounted: function () {
      this.getObject()
    },
    props: {
      showDefinition: {
        type: Object,
        default: () => {}
      },
      client: {
        type: Object
      },
      canUpdate: {
        type: Boolean,
        default: true
      },
      updateAction: {
        type: Function
      },
      canDelete: {
        type: Boolean,
        default: true
      },
      deleteAction: {
        type: Function
      },
      getObjectAction: {
        type: Function
      },
      externalObject: {
        type: Object
      },
      tableHeader: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      getObject () {
        return this.getObjectAction || this.getObjectLocal
      },
      object () {
        return this.getObjectAction !== undefined ? this.externalObject : this.localObject
      }
    },
    data: function () {
      return {
        localObject: {},
        tableFields: this.showDefinition.tableFields,
        urls: this.showDefinition.urls,
        title: this.showDefinition.title + (this.$route.params.id ? ' - ' + this.$route.params.id : ''),
        id: this.$route.params.id,
        cancelRoute: this.$route.query.origin ? '/' + this.$route.query.origin : (this.showDefinition.redirect ? '/' + this.showDefinition.redirect : '/')
      }
    },
    methods: {
      getObjectLocal: function () {
        store.commit('setLoading', true)
        var self = this
        const path = `${this.urls.showObject.url}`
        const id = self.id ? self.id : null
        const url = self.client.methods.api_url(path, id)
        const options = self.client.methods.api_options()
        axios[self.urls.showObject.method](url, options)
        .then(async function (response) {
          if (!Array.isArray(self.showDefinition.name)) {
            self.localObject = response.data[self.showDefinition.name]
          } else {
            self.localObject = response.data
            await Promise.all(self.showDefinition.name.map((name) => {
              self.localObject = self.localObject[name]
            }))
          }
          var temp = {}
          self.tableFields.forEach((field) => {
            temp[field.name] = _.get(self.localObject, field.key)
          })
          self.localObject = temp
          store.commit('setLoading', false)
        })
        .catch(function (error) {
          console.log(error)
          store.commit('setLoading', false)
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        })
      },
      editContact () {
        this.updateAction()
      },
      showDeleteModal () {
        this.deleteAction()
      }
    }
  }
</script>
<style>
  td.key {
  text-transform: uppercase;
  font-weight: 500;
  }

  .object-table th, .object-table td {
  min-width: 120px;
  padding: 10px 20px;
  }

  .form-group1 {
    margin: 0 0 0 0;
  }

  .form-group1 input {
    border: 1px solid black;
    border-radius: 5px;
  }

  .row.actions {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/objects/Show.vue